
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.871 8.368v-.159h-.544l-1.338.251-3.554 1.714s-.084-.752.502-1.171a67.425 67.425 0 001.087-.794l-.042-1.087s.084-.084.126-.084h.209s.083 0 .083.126v.752l1.213-.92V5.867s.042-.083.084-.083h.167s.125 0 .125.125v.836l1.966-1.463V3.4s.041-1.463.543-2.049C8 1.979 8.042 3.4 8.042 3.4v1.882l1.965 1.463v-.836c0-.125.125-.125.125-.125h.168c.042 0 .083.083.083.083v1.129l1.213.92v-.752c0-.126.084-.126.084-.126h.209c.083 0 .125.084.125.084l-.042 1.087s.502.376 1.088.794c.585.46.501 1.171.501 1.171L10.007 8.46l-1.338-.251h-.544v.162c.377.164.684.473.835.883.292.793-.124 1.711-.915 2.006-.059.309-.129.503-.129.503l1.547 1.255-.041.627-1.798-.585-.126.543-.125-.543-1.798.585-.042-.627 1.547-1.255s-.071-.198-.13-.511a1.56 1.56 0 01-.917-.91 1.486 1.486 0 01-.084-.419c-.04-.641.304-1.282.922-1.555z"}})])
          )
        }
      }
    